
import { GfrItem, getGfrItemMetadata, isGfrItem } from "@/constants/ReportDashboard/gfr-items"
import { ReportItem, getReportItemMetadata } from "@/constants/ReportDashboard/report-items"

export function getHeader(item: ReportItem | GfrItem) {
  if (isGfrItem(item)) {
    const metadata = getGfrItemMetadata(item);
    return metadata.shortened ?? metadata.header;
  }
  const metadata = getReportItemMetadata(item);
  return metadata.shortened ?? metadata.header;
}

export function getFullHeader(item: ReportItem | GfrItem) {
  if (isGfrItem(item)) {
    const metadata = getGfrItemMetadata(item);
    return metadata.header;
  }
  const metadata = getReportItemMetadata(item);
  return metadata.header;
}
